import { RichtextStoryblok } from "@/types/component-types"
import { ReactNode } from "react"
import Richtext from "../richtext/Richtext"
import { Paragraph } from "../typography/Body"

interface NewsCardProps {
  heading: string
  content: RichtextStoryblok
  link: ReactNode
}

const CarouselCard = ({ heading, content, link }: NewsCardProps) => {
  return (
    <article className="flex h-full min-h-[332px] flex-col whitespace-break-spaces break-words rounded-2xl bg-secondary-10 p-6 text-on-secondary-10 lg:p-8">
      <h3>{heading}</h3>
      <Paragraph as="div" size="small" className="grow">
        <Richtext content={content} />
      </Paragraph>
      {link}
    </article>
  )
}

export default CarouselCard
